import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class PhoStateFacade {
  private readonly statesResetSubject = new Subject<boolean>();
  private readonly sidebarStateSubject = new Subject<boolean>();
  private readonly assortmentLockSubject = new BehaviorSubject<unknown>(null);
  private readonly levelSubject = new BehaviorSubject<
    readonly unknown[] | null
  >(null);

  readonly statesReset$ = this.statesResetSubject.asObservable();
  readonly sidebarState$ = this.sidebarStateSubject.asObservable();
  readonly assortmentLock$ = this.assortmentLockSubject.asObservable();
  readonly level$ = this.levelSubject.asObservable();

  requestStatesReset(value: boolean): void {
    this.statesResetSubject.next(value);
  }

  setSidebarState(value: boolean): void {
    this.sidebarStateSubject.next(value);
  }

  setAssortmentLock(value: unknown): void {
    this.assortmentLockSubject.next(value);
  }

  setLevel(value: readonly unknown[] | null): void {
    this.levelSubject.next(value);
  }
}
